import React from 'react';
const PageForbidden = () => {
	return <div>You have no access to this page!</div>;
};

export default PageForbidden;
